// extracted by mini-css-extract-plugin
module.exports = {"downloadOptions":"downloadDropdown_downloadOptions__2ErDF","active":"downloadDropdown_active__27MFI"};